export default __webpack_public_path__ + "static/media/girl_2_ramp_young.63f8cb3a.jpg";